export const repairOrderSteps = {
  '10': '待接单/转单',
  '20': '待处理',
  '30': '待签到',
  '40': '待执行',
  '50': '申请延期中',
  '60': '申请强关中',
  '70': '待结单',
  '80': '待验收',
  '90': '待评价',
  '100': '转第三方处理',
  '101': '转第三方处理',
  '110': '转计划性维修',
  '111': '转计划性维修',
  '201': '驳回申请',
  '11': '派单完成',
  '21': '转单完成',
  '31': '接单完成',
  '41': '签到完成',
  '51': '工单延期',
  '61': '工单强关',
  '71': '处理完成',
  '81': '验收完成',
  '121': '评价完成',
  '131': '报事人评价完成',
  '141': '报修人评价完成',
  '91': '结单完成',
}

export const repairOrderStepColor = {
  '10': 'red',
  '20': 'pink',
  '30': 'pink',
  '40': 'pink',
  '50': 'red',
  '60': 'red',
  '70': 'orange',
  '80': 'blue',
  '90': 'blue',
  '100': 'orange',
  '101': 'orange',
  '110': 'orange',
  '111': 'orange',
  '201': 'red',
  '11': 'pink',
  '21': 'pink',
  '31': 'pink',
  '41': 'pink',
  '51': 'orange',
  '61': 'orange',
  '71': 'green',
  '81': 'green',
  '121': 'green',
  '91': 'green',
}

export const repairOrderStepList = [
  { value: '10', name: '待接单/转单'},
  { value: '20', name: '待调度员派单'},
  { value: '30', name: '待签到'},
  { value: '40', name: '待执行'},
  { value: '50', name: '申请延期中'},
  { value: '60', name: '申请强关中'},
  { value: '70', name: '待结单'},
  { value: '80', name: '待验收'},
  { value: '90', name: '待评价'},
  { value: '91', name: '结单完成'},
  { value: '100', name: '转第三方处理'},
  { value: '101', name: '转第三方处理'},
  { value: '110', name: '转计划性维修'},
]

export const repairOrderStatus = {
  '1': '正常',
  '2': '异常',
  '3': '撤销',
}

export const orderStatus = {
  '1': '常规',
  '2': '常规',
  '3': '拆单',
  '4': '转单',
  '5': '强关',
  '6': '常规',
}

export const resultCode = {
  '1': '正常',
  '2': '保养后正常',
  '3': '转计划性维修（带病运行）',
  '4': '转计划性维修（停止运行）',
}

export const mattersPicType = {
  '1': '报事现场图片',
  '2': '报事现场视频',
  '10': '现场签到',
  '11': '处理前照片',
  '12': '处理后照片',
  '16': '处理视频',
  '17': '处理人签名',
  '24': '验收签名',
}

export const repairsPicType = {
  '1': '报修现场图片',
  '2': '报修现场视频',
  '10': '现场签到',
  '11': '维修前照片',
  '12': '维修后照片',
  '16': '维修视频',
  '17': '维修人签名',
  '24': '验收签名',
}